import { defineStore } from 'pinia';

export const useApplicationStore = defineStore('application', {
  state: () => ({
    canInteract: true,
    isBooting: true,
    installPrompted: false,
    toolbarTitle: null,
    selectedCamera: null,
  }),

  actions: {
    allowInteraction() {
      this.canInteract = true;
    },

    blockInteraction() {
      this.canInteract = false;
    },

    bootComplete() {
      this.isBooting = false;
    },
  },
});
